import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@aichat/ui/components/ui/carousel";
import LinkPreviewComponent from "./link-preview-component";
import { ChevronLeft, ChevronRight } from "lucide-react";
import useCarouselApi from "@aichat/ui/hooks/useMainCarouselApi";
import { cn } from "@aichat/ui/lib/utils";
import { LinkPreviewComponent as TLinkPreviewComponent } from "@aichat/types/socket/widget.types";
import { HandleSendComponentParams } from "@aichat/types/widget";

type LinkPreviewListComponentProps = {
  type?: "portal-chat" | "widget-chat";
  isUser?: boolean;
  linkPreviews: TLinkPreviewComponent[];
  // eslint-disable-next-line no-unused-vars
  handleSendComponent?: (params: HandleSendComponentParams) => void;
};

function LinkPreviewListComponent({
  linkPreviews,
  type,
  isUser,
  handleSendComponent,
}: LinkPreviewListComponentProps) {
  const { setMainCarouselApi, canScrollPrev, canScrollNext } = useCarouselApi();

  return (
    <Carousel setApi={setMainCarouselApi}>
      <CarouselContent
        className={cn("py-1 mb-3 gap-0", {
          "justify-end": type === "portal-chat" && !isUser,
        })}
      >
        {linkPreviews.map((component) => (
          <CarouselItem key={component.url} className="basis-[55%]">
            <LinkPreviewComponent
              {...component}
              handleSendComponent={handleSendComponent}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious
        icon={<ChevronLeft />}
        className={cn("absolute left-[10px]", {
          hidden: !canScrollPrev,
        })}
      />
      <CarouselNext
        icon={<ChevronRight />}
        className={cn("absolute right-[10px]", {
          hidden: !canScrollNext,
        })}
      />
    </Carousel>
  );
}

export default LinkPreviewListComponent;
